import { mapGetters, mapState } from "vuex";
export default {
  // DATAs
  computed: {
    ...mapGetters({
      activitiesThemes: "core/activitiesThemes",
      ambiancesThemes: "core/ambiancesThemes",
      transportsThemes: "core/transportsThemes",
      travellersThemes: "core/travellersThemes"
    }),
    ...mapState({
      themesByCategory: state => state.core.themesByCategory,
      themesByCategoryLoading: state => state.core.themesByCategoryLoading,
      isFetchingThemesByCategory: state => state.core.isFetchingThemesByCategory
    })
  },
  // LIFE CYCLES HOOKS
  created() {
    if (
      this.themesByCategory.length === 0 &&
      this.themesByCategoryLoading === false &&
      this.isFetchingThemesByCategory === false
    ) {
      this.$store.dispatch("core/updateThemesByCategory");
    }
  }
};
